import ContactInfo from "./contact-info";

export default class PaymentMethod {
  constructor(data = {}) {
    this.id = data.id;
    this.hasAutoPay = data.hasAutoPay;
    this.isDefault = data.isDefault;
    this.savedInWP = data.savedInWP;
    this.type = data.type;
    this.companyName = data.companyName;
    this.hasPendingScheduledPayments = data.hasPendingScheduledPayments;
    this.hasPaymentMethod = data.hasPaymentMethod;
    this.billingDetails = new ContactInfo(data.billingDetails || {});

    if (this.isCreditCard) {
      this.cardNumber = data.cardNumber;
      this.cardName = data.cardName;
      this.cardCVV = data.cardCVV;
      this.savedCardType = data.cardType;
      this.token = data.token;
      if (data.cardExpiry) {
        this.setCardExpiry(data.cardExpiry);
      } else if (data.cardExpiryMonth && data.cardExpiryYear) {
        this.cardExpiryMonth = data.cardExpiryMonth;
        this.cardExpiryYear = data.cardExpiryYear;
      }
    }
    if (this.isBankDebit) {
      this.accountName = data.accountName;
      this.bsb = data.bsb;
      this.bsbTwo = data.bsbTwo || data.institutionNumber;
      this.account = data.account;
    }
  }

  get isCreditCard() {
    return this.type === "CreditCard";
  }

  get isBankDebit() {
    return this.type === "BankAccount";
  }

  get cardExpiry() {
    if (this.cardExpiryMonth && this.cardExpiryYear) {
      return `${this.cardExpiryMonth}/${this.cardExpiryYear}`;
    }
    return "";
  }

  get maskedCardNumber() {
    const cardNumberBlocks = this.cardNumber.match(/.{1,4}/g);
    return cardNumberBlocks[0] + " **** **** " + cardNumberBlocks[3];
  }

  get cardType() {
    if (this.savedCardType) {
      return this.savedCardType;
    }
    const cardTypeValidations = {
      visa: "^4",
      mastercard: "^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$",
      amex: "^3[47]",
      discover: "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)",
      diners: "^(36|30[0-5])",
      jcb: "^35(2[89]|[3-8][0-9])",
      union: "^(62[0-9]{14,17})$",
    };
    return Object.keys(cardTypeValidations).find((cardType) =>
      new RegExp(cardTypeValidations[cardType]).test(this.cardNumber)
    );
  }

  getPayload() {
    const payload = {
      IsDefault: this.isDefault,
      UniquePayerReferenceId: this.id,
    };
    if (this.isCreditCard) {
      Object.assign(payload, {
        TokenFromCardProvider: this.token,
        MaskedCreditCard: {
          cardName: this.cardName,
          cardMaskedNumber: this.maskedCardNumber,
          cardExpiry: this.cardExpiry,
          cardCVV: this.cardCVV,
        },
      });
    } else if (this.isBankDebit) {
      Object.assign(payload, {
        BankAccount: {
          AccountName: this.accountName,
          AccountNumber: this.account,
          Bsb: this.bsb + (this.bsbTwo || ""),
        },
      });
    }
    return payload;
  }

  getPayrixPayload() {
    return {
      Card: {
        CardNumber: this.cardNumber,
        CardholderName: this.cardName,
        ExpiryYear: `20${this.cardExpiryYear}`,
        ExpiryMonth: this.cardExpiryMonth,
        Ccv: this.cardCVV,
      },
    };
  }

  setCardExpiry(expiry) {
    if (expiry) {
      let [month, year] = expiry.split("/");
      if (year && year.length === 4) {
        year = year.slice(-2);
      }
      this.cardExpiryMonth = month;
      this.cardExpiryYear = year;
    }
  }
}
